<template>
    <div>
        <b-modal size="xl" ref="finderModal" :title="prefix + title" hide-footer>
            <TipoValorList @close="tipoValorSelect" :title="prefix + title + ' >'" />
        </b-modal>
        <lg-form-input-finder v-model="inputValue" fieldDescription="descricao" :label="label"
            invalidFeedback="Tipo de Valor deve ser informado!" description="" @click:button="show"
            @clear="handleClear">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </div>
</template>

<script>
import TipoValorList from "@/modules/cadastros/tipovalor/TipoValorList.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";

export default {
    components: { LgFormInputFinder, TipoValorList },

    props: {
        id: String,
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Tipo de Valor",
        },
    },

    data() {
        return {
            inputValue: this.value,
            title: "Tipo de Valor",
        };
    },

    watch: {
        value(newValue) {
            this.inputValue = newValue;
        },
        inputValue(newValue) {
            this.$emit("input", newValue);
        },
    },

    methods: {
        show() {
            this.$refs.finderModal.show();
        },

        handleClear() {
            this.inputValue = null;
            this.$emit("input", null);
            this.$refs.finderModal.hide();

        },

        tipoValorSelect(item) {
            this.inputValue = item;
            this.$emit("input", item);
            this.$refs.finderModal.hide();

        },
    },
};
</script>
